import * as React from 'react';
import './ArSummary.scss';
import LocaleFormating from 'src/translation/localeFormating';
import ArSummaryModel from 'src/model/arSummary.model';
import ArSummaryCard from '../components/ArSummaryCard';

export interface IArSummaryProps {
  t: any;
  ArSummaryContent: ArSummaryModel;
  renderColumnType: 'wide' | 'normal';
}

const ArSummary: React.SFC<IArSummaryProps> = props => {
  const {
    currentMonthBalance,
    openArBalance,
    firstMonthPastDueDate,
    secondMonthPastDueDate,
    thirdMonthPastDueDate
  } = props.ArSummaryContent;

  const { renderColumnType } = props;

  const numberFormat = (value: number) => {
    return value
      ? LocaleFormating.formatCurrency(parseFloat(value.toString()))
      : LocaleFormating.formatCurrency(0.0);
  };

  const { t } = props;

  return (
    <div className="rp-arSummary">
      <div className="rp-ar-summary-desktop-container">
        <div
          className={
            renderColumnType === 'wide'
              ? 'rp-ar-summary-desktop-wide-column'
              : 'rp-ar-summary-desktop-column'
          }
        >
          <ArSummaryCard
            label={`${t('accountInfoHeader.arBalance')}:`}
            value={numberFormat(openArBalance)}
            past={false}
          />
        </div>
        <div
          className={
            renderColumnType === 'wide'
              ? 'rp-ar-summary-desktop-wide-column'
              : 'rp-ar-summary-desktop-column'
          }
        >
          <ArSummaryCard
            label={`${t('accountInfoHeader.currentBalance')}:`}
            value={numberFormat(currentMonthBalance)}
            past={false}
          />
        </div>
        <div
          className={
            renderColumnType === 'wide'
              ? 'rp-ar-summary-desktop-wide-column'
              : 'rp-ar-summary-desktop-column'
          }
        >
          <ArSummaryCard
            label={`${t('invoices.thirtyPastDueTxt')}:`}
            value={numberFormat(firstMonthPastDueDate)}
            past={true}
          />
        </div>

        <div
          className={
            renderColumnType === 'wide'
              ? 'rp-ar-summary-desktop-wide-column'
              : 'rp-ar-summary-desktop-column'
          }
        >
          <ArSummaryCard
            label={`${t('invoices.sixtyPastDueTxt')}:`}
            value={numberFormat(secondMonthPastDueDate)}
            past={true}
          />
        </div>

        <div
          className={
            renderColumnType === 'wide'
              ? 'rp-ar-summary-desktop-wide-column'
              : 'rp-ar-summary-desktop-column'
          }
        >
          <ArSummaryCard
            label={`${t('invoices.ninetyPastDueTxt')}:`}
            value={numberFormat(thirdMonthPastDueDate)}
            past={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ArSummary;
